import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner, VStack } from '@chakra-ui/react';
import { PlaybookCard } from '@src/components/sco/Education/PlaybookList/PlaybookCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { gql } from '@src/lib/gql';
import uniqBy from 'lodash/uniqBy';
import React, { useEffect, useState } from 'react';
type PlaybookListProps = {};
export const PlaybookList = props => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [playbooks, setPlaybooks] = useState(t0);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = gql`
    query coursesQuery {
      scoPlaybooks {
        id
        topic {
          colorHexCode
        }
        comingSoon
        courseId
        illustration
        primaryCategorySlug
        slug
        teaser
        title
      }
    }
  `;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const playbooksQuery = useQuery(t1);
  let t2;
  if ($[2] !== playbooksQuery.data) {
    t2 = () => {
      if (playbooksQuery.data && playbooksQuery.data.scoPlaybooks) {
        setPlaybooks(prev => uniqBy([...prev, ...playbooksQuery.data.scoPlaybooks.filter(_temp)], _temp2));
      }
    };
    $[2] = playbooksQuery.data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = playbooksQuery.data?.scoPlaybooks;
  let t4;
  if ($[4] !== t3) {
    t4 = [t3];
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t2, t4);
  let t5;
  if ($[6] !== getBreakpointValue || $[7] !== playbooks) {
    t5 = playbooks && <VStack gap={8} width="full">{playbooks.map((playbook, index) => <PlaybookCard key={playbook.id} bgColor={`${playbook.topic?.colorHexCode}`} illustration={playbook.illustration} summary={playbook.teaser} tag="Tag" tagColor={playbook.topic?.colorHexCode} targetUrl={`/playbooks/${playbook.slug}`} title={playbook.title} direction={getBreakpointValue([index % 2 ? "column-reverse" : "column", index % 2 ? "column-reverse" : "column", index % 2 ? "column-reverse" : "column", index % 2 ? "row" : "row-reverse", index % 2 ? "row" : "row-reverse"])} />)}</VStack>;
    $[6] = getBreakpointValue;
    $[7] = playbooks;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== playbooksQuery.error) {
    t6 = playbooksQuery.error && <Center padding="24px">{"Error: "}{playbooksQuery.error.message}</Center>;
    $[9] = playbooksQuery.error;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== playbooksQuery.loading) {
    t7 = playbooksQuery.loading ? <Center padding="24px"><Spinner /></Center> : <div />;
    $[11] = playbooksQuery.loading;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <>{t5}{t6}{t7}</>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
function _temp(p) {
  return !p.comingSoon;
}
function _temp2(x) {
  return x.id;
}